module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "Search"
    },
    on: {
      "change": _vm.startSearch
    },
    model: {
      value: (_vm.searchFilter),
      callback: function($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "size": "small"
    },
    on: {
      "click": _vm.startSearch
    }
  }, [_vm._v(_vm._s(_vm.lang.butSearch))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.searchFilter = '';
        _vm.getRecords();
      }
    }
  }, [_vm._v("C")])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.lang.butAdd))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.content,
      "stripe": "",
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "View",
      "width": "80",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Email",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "active",
      "label": "Active",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-switch', {
          attrs: {
            "disabled": "",
            "width": 35,
            "xactive-color": "#FFCE9F",
            "inactive-color": "#ccc"
          },
          model: {
            value: (scope.row.active),
            callback: function($$v) {
              _vm.$set(scope.row, "active", $$v)
            },
            expression: "scope.row.active"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.row)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "cmdIcon",
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-d-arrow-left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeForm.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": _vm.pagewidth > 800 ? 'prev,pager,next,jumper,sizes' : 'prev,pager,next,jumper',
      "total": _vm.mainTotal,
      "current-page": _vm.currentPage,
      "page-sizes": [10, 15, 25, 50, 100, 1000],
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.selectPage,
      "size-change": _vm.selectPagesize
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "80%",
      "margin": "9px",
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.mainTotal) + " records found")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editTitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "125px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-date"
  }), _vm._v(" View")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "View : "
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": this.editMode == 'save',
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['code']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'code', $$v)
      },
      expression: "editForm['code']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name : "
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['name']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'name', $$v)
      },
      expression: "editForm['name']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sites : "
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm['sitelist']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'sitelist', $$v)
      },
      expression: "editForm['sitelist']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " Fields : "
    }
  }, [_c('el-input', {
    attrs: {
      "rows": "5",
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm['select']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'select', $$v)
      },
      expression: "editForm['select']"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Active : "
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 35,
      "xactive-color": "#FDAA59",
      "inactive-color": "#ccc"
    },
    model: {
      value: (_vm.editForm['active']),
      callback: function($$v) {
        _vm.$set(_vm.editForm, 'active', $$v)
      },
      expression: "editForm['active']"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-upload2"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butCancel))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-edit",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.butSave))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e3d0430"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/view.vue
// module id = 644
// module chunks = 1